$(function(){
  $(document).on( "mouseout", function(e) {
    var Cookie = $.cookie('mouseleavePP');

    // If this is an autocomplete element.
		if(e.target.tagName.toLowerCase() == "input")
			return;
    // Get the current viewport width.
		var vpWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

		// If the current mouse X position is within 50px of the right edge
		// of the viewport, return.
		if(e.clientX >= (vpWidth - 50))
			return;

    // If the current mouse Y position is not within 50px of the top
		// edge of the viewport, return.
		if(e.clientY >= 50)
			return;

		// Reliable, works on mouse exiting window and
		// user switching active program
		var from = e.relatedTarget || e.toElement;
		if(!from){
      if( typeof(Cookie) == 'undefined'  ){
        $.cookie("mouseleavePP", 1 , {expires: 1 });
          // $('#popap-exit').modal();
      }else{

      }
    }
  });


  $('body').on('submit','.popup-exit-js-validate-form', function (e) {
    if (e.isDefaultPrevented()) {
      // handle the invalid form...
    } else {

      $.ajax({
        type: "POST",
        url: $('.popup-exit-js-validate-form').attr('action'),
        data: $('.popup-exit-js-validate-form').serialize(),
        dataType: 'json',
        success: function(data){

          if(data.status == "success"){

            $('.popup-exit-js-validate-form .msg-success').removeClass('hidden');
            $('.popup-exit-js-validate-form input:not(.popup-exit-js-validate-form--send)').val("");
            $('.popup-exit-js-validate-form textarea').val("");

            setTimeout(function() {

              $('.popup-exit-js-validate-form .msg-success').addClass('hidden');
              $('#popap-exit').modal('hide');

            }, 2000);
          }else{
          }
        }
      });
    }
    return false;
  });

});
